import { render } from "./editor.vue?vue&type=template&id=565c2ed6&scoped=true&ts=true"
import script from "./editor.vue?vue&type=script&lang=ts"
export * from "./editor.vue?vue&type=script&lang=ts"

import "./editor.vue?vue&type=style&index=0&id=565c2ed6&lang=less&scoped=true"
import "./editor.vue?vue&type=style&index=1&id=565c2ed6&lang=less"

import exportComponent from "/jenkins/workspace/www.soyoung.com-vue3-pc-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565c2ed6"]])

export default __exports__